import React, {useEffect, useState} from "react"
import {Button, Popconfirm, Table, Typography} from "antd"
import {useTranslation} from "react-i18next"
import {useDispatch, useSelector} from "react-redux";
import DeleteIcon from "../../../components/Icons/delete.svg";
import {getCorrectionFactors} from "../../NRI/ReCorrectionFactor/store/actions";
import {colors, getRefArea, remove, setObjIndex, setUnitCosts, treeFromList} from "../helpers";
import PriceDetails from "../priceDetails";
import Notifications from "../../../helpers/Notifications";

const {Text} = Typography;

const PtmList = (props) => {
    const {project, setProject, formState} = props
    const [state, setState] = useState(null)
    const [ptmInfo, setPtmInfo] = useState({visible: false, record: null});
    const {t} = useTranslation(['common', 'nri', 'action', 'kit'])
    const referenceUnits = useSelector(state => state.referenceUnitReducer.list)
    const reCorrectionFactors = useSelector(state => state.reCorrectionFactorReducer.list)
    const zones = useSelector(state => state.reZoneReducer.list)
    const dispatch = useDispatch()

    useEffect(_ => {
        if (reCorrectionFactors.length === 0) {
            dispatch(getCorrectionFactors())
        }
    }, [])

    useEffect(_ => {
        setPrice(project)
    }, [project, reCorrectionFactors, formState])

    function setPrice(project) {
        if (project.ptms.length > 0) {
            let treeData = treeFromList(project.ptms, 2)
            treeData = setUnitCosts(treeData, project.objects)
            if(zones.length > 0 && referenceUnits.length > 0 && reCorrectionFactors.length > 0) {
                const refUnitCode = referenceUnits.find(r => r.id === formState.referenceUnitId).code
                if (refUnitCode) {
                    let x = getRefArea(refUnitCode)
                    treeData = treeData.map(n => {
                        const zone = zones.find(r => r.code === n.zoneCode)
                        const correctionFactor = reCorrectionFactors?.find(r =>
                            r.reRegionBuiltId === n.regionId && r.reZoneBuiltId === zone.id &&
                            r.reRegionId === formState.regionId && r.reZoneId === formState.zoneId
                        )
                        let corrFactor
                        if (!correctionFactor) {
                            Notifications.errorNotice(n.objCode, `Не найден коэфф. для ${n.regionName} и зоны ${n.zoneCode} применён 1`, 20)
                            corrFactor = 1
                        } else {
                            corrFactor = correctionFactor.value
                        }
                        n.corrFactor = corrFactor
                        n.price = n[x] * formState.value * corrFactor * formState.costIndex
                        return n
                    })
                }
            }

            treeData = setObjIndex(treeData, project.objects, formState.vat)
            if (formState.vat) {
                let totalPrice = 0
                treeData.forEach((ptm) => {
                    if (ptm.key !== '999_vat' && !ptm.key.includes('999_total_'))
                        totalPrice += ptm.price
                });
                let totalRecord = {key: 999 + '_total', code: '', price: totalPrice, name: `Итого без НДС:`}
                let index = treeData.length - 1
                treeData.splice(index, 0, totalRecord)//на предпоследнее место, последнее должно быть занято ндс-ом
            }
            setState(treeData)
        }
    }

    const columns = [
        {
            key: 'code',
            title: 'Код ПТМ',
            render: (key, record) => {
                let res = null
                if (record.priceDetails || record.ptmDescription || record.limited) {
                    res = <a
                        style={{textDecoration: 'underline', color: 'blue', position: 'absolute', zIndex: '100'}}
                        onClick={() => showPtmDescription(record)}
                    >{record.code}</a>
                } else {
                    res = record.code
                }
                return <div style={{whiteSpace: 'nowrap'}}>{res}</div>
            }
        },
        {
            key: 'objCode',
            title: 'Код объекта',
            //ellipsis: true,
            render: (data) => <div style={{whiteSpace: 'nowrap', overflow: 'hidden'}}>{data.objCode}</div>
        },
        {
            key: 'regionName',
            title: t('nri:regionBuilt'),
            ellipsis: true,
            render: (data) => <div style={{whiteSpace: 'break-spaces', lineHeight: '1.1'}}>{data.regionName}</div>
        },
        {
            key: 'zoneCode',
            title: t('nri:zoneBuilt'),
            dataIndex: 'zoneCode',
            width: '5%',
            align: 'center',
        },
        {
            key: 'name',
            title: 'Наименование ПТМ',
            ellipsis: true,
            //dataIndex: 'name',
            width: '30%',
            render: (data) => data.name
        },
        {
            key: 'area',
            title: `${t('common:cost')} ${t('kit:costM2Area')}`,
            //dataIndex: 'area',
            align: 'center',
            render: (data) => data.area?.toFixed(3)
        },
        {
            key: 'area2',
            title: `${t('common:cost')} ${t('kit:costM2UseFul')}`,
            //dataIndex: 'area2',
            align: 'center',
            render: (data) => data.area2?.toFixed(3)
        },
        {
            key: 'value',
            title: `${t('common:cost')} ${t('kit:costM3Volume')}`,
            //dataIndex: 'value',
            align: 'center',
            render: (data) => data.value?.toFixed(3)
        },
        {
            key: 'power',
            title: `${t('common:cost')} ${t('kit:costUnitOfPower')}`,
            //dataIndex: 'power',
            align: 'center',
            render: (data) => data.power?.toFixed(3)
        },
        {
            key: 'corrFactor',
            title: 'Коэфф. по областям и зонам',
            align: 'center',
            //width: '10%',
            render: (data) => data.corrFactor
        },
        {
            key: 'price',
            title: 'Стоимость руб.',
            //dataIndex: 'price',
            align: 'center',
            //width: '10%',
            render: (data) => data.price?.toFixed(3)
        },
        {
            dataIndex: "key",
            key: 'key',
            width: 30,
            render: (key, record) => {
                if (record.level <= 5) {
                    return (
                        <div className="changeIcon">
                            <Popconfirm
                                cancelText={t('common:no')}
                                okText={t('common:yes')}
                                placement="left"
                                title={t('valid:sureToDelete')}
                                onCancel={(e) => {
                                    e.stopPropagation()
                                    return null
                                }}
                                onConfirm={(e) => {
                                    e.stopPropagation()
                                    remove(key, project, setProject)
                                }}
                            >
                                <img alt=""
                                    src={DeleteIcon}
                                    title={t('action:delete')}
                                />
                            </Popconfirm>
                        </div>
                    )
                }
            }
        }
    ];

    const showPtmDescription = (record) => {
        setPtmInfo({visible: true, record: record})
    }

    return (<>
            <Table
                columns={columns}
                dataSource={state?.map((el, idx) => ({key: idx, ...el}))}
                pagination={false}
                size="small"
                style={{paddingBottom: "20px"}}
                className='ptmList'
                rowClassName={(record) => colors[record.index]?.replace('#', '')}
                //scroll={{ x: 'calc(700px + 50%)' }}
                summary={(pageData) => {
                    let totalPrice = 0;
                    pageData.forEach(({key, price}) => {
                        if (!key.includes('999_total'))
                            totalPrice += price;
                    });
                    return (
                        <Table.Summary fixed>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={4}>
                                    <div className="changeIcon">
                                        <Popconfirm
                                            cancelText={t('common:no')}
                                            okText={t('common:yes')}
                                            placement="left"
                                            title={t('kit:sureToDelPtm')}
                                            onCancel={(e) => {
                                                e.stopPropagation()
                                                return null
                                            }}
                                            onConfirm={(e) => {
                                                e.stopPropagation()
                                                setProject({ptms: [], objects: []})
                                            }}
                                        >
                                            <Button danger>
                                                <a>{t('kit:cleanTable')}</a>
                                            </Button>
                                        </Popconfirm>
                                    </div>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1} colSpan={6}>Итого:</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>
                                    <Text type="danger">{totalPrice?.toFixed(3)}</Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </Table.Summary>
                    )
                }}
            />
            {ptmInfo.record &&
                <PriceDetails
                    ptmInfo={ptmInfo}
                    setPtmInfo={setPtmInfo}
                />
            }
        </>
    )
}
export default PtmList